export default class TransactionalityViewModel {
  readonly v_money_config = {
    precision: 0,
  };
}
